(function() {
    'use strict';

    angular
        .module('app.parametros')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/parametros',
                config: {
                    templateUrl: 'app/parametros/list.html',
                    controller: 'parametros.List',
                    controllerAs: 'vm',
                    title: 'List'
                }
            },
            {
                url: '/editar-parametro/:id?',
                config: {
                    templateUrl: 'app/parametros/edit.html',
                    controller: 'parametros.Edit',
                    controllerAs: 'vm',
                    title: 'Edit'
                }
            }
        ];
    }
})();
